import React from 'react';
import { Link } from 'react-router-dom';
import { Sparkles, ChevronRight } from 'lucide-react';

export const TiePromoBadge = () => {
  return (
    <Link
      to="/galerie"
      className="group block mx-4 sm:mx-auto max-w-5xl mt-4"
      data-testid="tie-promo-badge"
    >
      <div className="relative overflow-hidden rounded-2xl bg-gradient-to-r from-slate-900 via-[#0205B3] to-slate-900 shadow-2xl ring-2 ring-cyan-300/60 hover:ring-cyan-300 transition-all duration-300 hover:scale-[1.01]">
        {/* Shimmer effect */}
        <div className="absolute inset-0 bg-[linear-gradient(110deg,transparent_40%,rgba(103,232,249,0.2)_50%,transparent_60%)] bg-[length:200%_100%] animate-[shimmer_3s_linear_infinite]" aria-hidden="true"></div>

        <div className="relative flex items-center gap-3 sm:gap-5 px-4 sm:px-6 py-4">
          {/* Blinking cyan dot */}
          <div className="relative flex-shrink-0">
            <span className="absolute inline-flex h-4 w-4 rounded-full bg-cyan-300 opacity-75 animate-ping"></span>
            <span className="relative inline-flex rounded-full h-4 w-4 bg-cyan-300"></span>
          </div>

          <Sparkles className="h-7 w-7 sm:h-8 sm:w-8 text-cyan-300 flex-shrink-0 animate-pulse" />

          <div className="flex-1 min-w-0">
            <div className="flex items-center gap-2 flex-wrap">
              <span className="bg-cyan-300 text-gray-900 px-2 py-0.5 rounded text-xs font-black uppercase tracking-wider">
                Tarif spécial
              </span>
              <span className="text-white font-black text-base sm:text-xl tracking-wide">
                Nettoyage cravate à <span className="text-cyan-300">5,50 €</span>
              </span>
            </div>
            <p className="text-blue-100 text-xs sm:text-sm mt-0.5 font-medium">
              Cravates nettoyées avec soin — éclat, fraîcheur et tenue impeccable. Dans nos 2 pressings AQUABLUENET.
            </p>
          </div>

          <ChevronRight className="h-6 w-6 sm:h-8 sm:w-8 text-cyan-300 flex-shrink-0 group-hover:translate-x-1 transition-transform duration-300" />
        </div>
      </div>
    </Link>
  );
};
